/**
 * ArtifactStatusLine — top row of the artifact summary: artifact id (with copy)
 * on the left, overall status and current location on the right. Pure
 * presentational.
 */
import Badge from '@cloudscape-design/components/badge';
import Box from '@cloudscape-design/components/box';
import StatusIndicator from '@cloudscape-design/components/status-indicator';
import CopyToClipboard from '@cloudscape-design/components/copy-to-clipboard';
import { ArtifactDetailView } from 'src/store/slices/artifactDetail/artifactDetailTypes';

interface ArtifactStatusLineProps {
  id: string;
  statusLabel: string;
  statusType: ArtifactDetailView['statusType'];
  locationBadge: string;
}

export const ArtifactStatusLine = ({ id, statusLabel, statusType, locationBadge }: ArtifactStatusLineProps) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, flexWrap: 'wrap' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <Box variant="h1">{id}</Box>
      <CopyToClipboard
        variant="icon"
        textToCopy={id}
        copyButtonAriaLabel="Copy artifact id"
        copySuccessText="Artifact id copied"
        copyErrorText="Failed to copy artifact id"
      />
    </div>

    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
      <StatusIndicator type={statusType}>{statusLabel}</StatusIndicator>
      <Badge color="grey">{locationBadge}</Badge>
    </div>
  </div>
);
